<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="py-4 bg-secondary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-md-6" >
                <template #default>   <m-section-300 v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.clinicyas.ir\/storage\/assets\/Tizer Johar 9 1-1.mp4","autoplay":true,"muted":true,"loop":false,"poster":null,"muteButton":true,"playButton":true,"fullScreenButton":true},...{}}' :style='"border-radius: 15px;\nheight:400px;"' class="" >
                <template #full_screen>تمام صفحه   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #mute>صدا   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #p-1>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                
                <template #play>پخش   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-section-300></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-md-6  my-auto px-4" >
                <template #default>   <m-heading-3 v-bind='{...{},...{}}' :style='""' class="text-dark" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-primary mt-4 col-12" >
                <template #default>مراقبت ها    </template>
                </m-h3></template>
                </m-heading-3><m-p v-bind='{...{},...{}}' :style='""' class="my-auto text-justify pt-3" >
                <template #default>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان    </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection300 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section300'; import mHeading3 from '@moeinmdn/miw-alpha-components/src/package/Heading/Heading3'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection300,mHeading3,mH3,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
